import { NavLink, useLocation } from 'react-router-dom'
import { useUIStore } from '@/stores/ui.store'
import { useAuthStore } from '@/stores/auth.store'
import {
    LayoutDashboard,
    Activity,
    Users,
    Car,
    FileText,
    Receipt,
    Package,
    Plug,
    Bell,
    Shield,
    AlertTriangle,
    ChevronLeft,
    ChevronRight,
    X,
    Building2,
    Settings,
    ClipboardList,
    XCircle,
    Handshake,
    BookOpen,
    Wallet,
    Smartphone,
    Heart,
} from 'lucide-react'

const navItems = [
    { to: '/admin', icon: LayoutDashboard, label: 'Dashboard', end: true },
    { to: '/admin/associados', icon: Users, label: 'Associados' },
    { to: '/admin/entidades', icon: Building2, label: 'Entidades' },
    { to: '/admin/veiculos', icon: Car, label: 'Veículos' },
    { to: '/admin/contratos', icon: FileText, label: 'Contratos' },
    { to: '/admin/cancelamentos', icon: XCircle, label: 'Cancelamentos' },
    { to: '/admin/faturas', icon: Receipt, label: 'Faturas' },
    { to: '/admin/cobrancas-placa', icon: ClipboardList, label: 'Cobranças c/ Placa' },
    { to: '/admin/servicos', icon: Package, label: 'Serviços' },
    { to: '/admin/fidelidade', icon: Heart, label: 'Fidelidade' },
    { to: '/admin/integracoes', icon: Plug, label: 'Integrações' },
    { to: '/admin/parceiros', icon: Handshake, label: 'Parceiros', end: true },
    { to: '/admin/parceiros/gestao', icon: Wallet, label: 'Gestão Parceiros' },
    { to: '/admin/api-docs', icon: BookOpen, label: 'API Docs' },
    { to: '/admin/integracao-logs', icon: Activity, label: 'Logs Integração' },
    { to: '/admin/notificacoes', icon: Bell, label: 'Notificações' },
    { to: '/admin/notificacoes/push', icon: Smartphone, label: 'Push PWA' },
    { to: '/admin/audit', icon: Shield, label: 'Auditoria' },
    { to: '/admin/dlq', icon: AlertTriangle, label: 'Dead Letter Queue' },
    { to: '/admin/settings', icon: Settings, label: 'Configurações' },
]

export function Sidebar() {
    const { sidebarOpen, sidebarCollapsed, setSidebarOpen, setSidebarCollapsed } = useUIStore()
    const tenant = useAuthStore((s) => s.tenant)
    const location = useLocation()

    return (
        <>
            {/* Mobile overlay */}
            {sidebarOpen && (
                <div
                    className="fixed inset-0 bg-black/40 backdrop-blur-sm z-40 lg:hidden"
                    onClick={() => setSidebarOpen(false)}
                />
            )}

            {/* Sidebar */}
            <aside
                className={`
          fixed top-0 left-0 h-full z-50 flex flex-col
          bg-surface-950 text-white
          transition-all duration-300 ease-in-out
          ${sidebarCollapsed ? 'w-[72px]' : 'w-[260px]'}
          ${sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        `}
            >
                {/* Header */}
                <div className="flex items-center justify-between px-4 h-16 border-b border-white/10">
                    {!sidebarCollapsed && (
                        <div className="flex items-center gap-3 min-w-0">
                            <div className="w-8 h-8 rounded-lg bg-primary-600 flex items-center justify-center text-sm font-bold flex-shrink-0">
                                V
                            </div>
                            <div className="min-w-0">
                                <p className="text-sm font-semibold truncate">
                                    {tenant?.nome || 'VeicularSaaS'}
                                </p>
                                <p className="text-xs text-white/40 truncate">
                                    {tenant?.slug || 'sistema'}
                                </p>
                            </div>
                        </div>
                    )}

                    {/* Mobile close */}
                    <button
                        onClick={() => setSidebarOpen(false)}
                        className="lg:hidden p-1.5 rounded-lg hover:bg-white/10 transition-colors"
                    >
                        <X size={18} />
                    </button>

                    {/* Desktop collapse */}
                    <button
                        onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                        className="hidden lg:block p-1.5 rounded-lg hover:bg-white/10 transition-colors"
                    >
                        {sidebarCollapsed ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
                    </button>
                </div>

                {/* Navigation */}
                <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-1">
                    {navItems.map((item) => {
                        const isActive = item.end
                            ? location.pathname === item.to
                            : location.pathname.startsWith(item.to)

                        return (
                            <NavLink
                                key={item.to}
                                to={item.to}
                                end={item.end}
                                onClick={() => setSidebarOpen(false)}
                                className={`
                  flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium
                  transition-all duration-200
                  ${isActive
                                        ? 'bg-primary-600/20 text-primary-400'
                                        : 'text-white/60 hover:text-white hover:bg-white/5'
                                    }
                  ${sidebarCollapsed ? 'justify-center' : ''}
                `}
                                title={sidebarCollapsed ? item.label : undefined}
                            >
                                <item.icon size={20} className="flex-shrink-0" />
                                {!sidebarCollapsed && <span>{item.label}</span>}
                            </NavLink>
                        )
                    })}
                </nav>

                {/* Footer */}
                {!sidebarCollapsed && (
                    <div className="px-4 py-3 border-t border-white/10">
                        <p className="text-xs text-white/30">
                            VeicularSaaS v1.0.0
                        </p>
                    </div>
                )}
            </aside>
        </>
    )
}
